import type { ThemeOptions } from "@mui/material/styles";
import { useTenantBrandingContext } from "@/context/TenantBrandingProvider";

/**
 * BW base themes + per-tenant `themeOptions` from `GET /tenant-branding/me`, with table zebra striping.
 */
export function useTenantBrandedThemes(): { light: ThemeOptions; dark: ThemeOptions } {
  return useTenantBrandingContext().themes;
}
